/**
 * BETA — audit log queries.
 */
import { paginate, matchSearch } from "./_utils.js";

export function register(route) {
  route("GET", "/audit", (ctx) => {
    const { params, store } = ctx;
    let rows = [...(store.data.audit || [])];
    if (params.user_id) rows = rows.filter((a) => a.user_id === params.user_id);
    if (params.entite) rows = rows.filter((a) => a.entite === params.entite);
    if (params.action) rows = rows.filter((a) => a.action === params.action);
    if (params.date_debut) rows = rows.filter((a) => a.created_at >= params.date_debut);
    if (params.date_fin) rows = rows.filter((a) => a.created_at <= params.date_fin + "T23:59:59.999Z");
    if (params.search)
      rows = rows.filter((a) => matchSearch(a, params.search, ["message", "entite_id", "ip_address"]));
    rows.sort((a, b) => (a.created_at > b.created_at ? -1 : 1));
    return paginate(rows, params);
  });

  route("GET", "/audit/users-list", (ctx) =>
    ctx.store.data.users.map((u) => ({ id: u.id, nom: u.nom, prenom: u.prenom, role: u.role })),
  );
}
